const Main = () => import('@/views/Main.vue')

const systemRouter = {
    path: '/system',
    name: 'System',
    component: Main,
    icon: require(`@/assets/images/menu-icons/icon_system_20_20.png`),
    icon_active: require(`@/assets/images/menu-icons/icon_system_hover_20_20.png`),
    children: [{
        path: 'role',
        name: 'RoleManage',
        component: () => import('@/views/System/RoleManage.vue'),
        meta: {
            title: '角色管理',
            roles: ['role']
        }
    }, {
        path: 'adminuser',
        name: 'AccountManage',
        component: () => import('@/views/System/AccountManage.vue'),
        meta: {
            title: '帐号管理',
            roles: ['adminuser']
        }
    },{
        path: 'join-logistics',
        name: 'JoinLogistics',
        component: () => import('@/views/System/JoinLogistics.vue'),
        meta: {
            title: '加盟物流管理',
            roles: ['adminuser']
        }
    },{
        path: 'owner-cost',
        name: 'ShipperDenominatedRules',
        component: () => import('@/views/System/ShipperDenominatedRules.vue'),
        meta: {
            title: '计价规则管理',
            roles: ['cost']
        }
    },
	{
	   path: 'department-position',
	   name: 'DepartmentSetting',
	   component: () => import('@/views/System/DepartmentSetting.vue'),
	  meta: {
	      title: '部门职位设置',
	      roles: ['role']
	  }
	},
	
    {
        path: 'basedata',
        name: 'PlatformSetting',
        component: () => import('@/views/System/PlatformSetting.vue'),
        meta: {
            title: '平台参数设置',
            roles: ['basedata']
        }
    },
	{
	    path: 'noticedata',
	    name: 'NoticeSetting',
	    component: () => import('@/views/System/NoticeSetting.vue'),
	    meta: {
	        title: '平台说明配置',
	        roles: ['basedata']
	    }
	},
	{
	    path: 'logisticsSystem',
	    name: 'logisticsSystem',
	    component: () => import('@/views/System/logisticsSystem.vue'),
	    meta: {
	        title: '物流软件账户',
	        roles: ['logisticsSystem']
	    }
	},
	{
	    path: 'jxcAccount',
	    name: 'jxcAccount',
	    component: () => import('@/views/System/jxcAccount.vue'),
	    meta: {
	        title: '进销存软件账户',
	        roles: ['JXCSystem']
	    }
	},
    {
        path: 'recharge-activity',
        name: 'rechargeActivity',
        component: () => import('@/views/System/rechargeActivity.vue'),
        meta: {
            title: '充值活动设置',
            roles: ['recharge-activities']
        }
    }
    ],
    meta: {
        title: '系统管理',
        roles: ['system']
    }
}

export default systemRouter